import * as React from 'react'
import { Link } from 'react-router-dom'

import { hashToCollection, getQuestionConceptUID } from '../../libs'


class QuestionListByConcept extends React.Component<any, any> {
  constructor(props) {
    super(props)

    this.renderQuestionLinks = this.renderQuestionLinks.bind(this)
    this.mapConceptsToList = this.mapConceptsToList.bind(this)
  }

  renderLabel(concept) {
    return (
      <p className="menu-label">
        {concept.name}
      </p>
    );
  }

  renderQuestionLinks(questions) {
    const { basePath } = this.props;
    let filtered;
    if (!this.props.showOnlyArchived) {
      filtered = questions.filter((question) => question.flag !== "archived" )
    } else {
      filtered = questions.filter((question) => question.flag === "archived" )
    }
    return filtered.map((question) => {
      if (question.prompt) {
        return (
          <li key={question.key}>
            <Link to={'/admin/' + basePath + '/' + question.key + '/responses'}>
              <span dangerouslySetInnerHTML={{ __html: question.prompt }} />
            </Link>
          </li>
        );
      }
    });
  }

  renderConceptWithQuestions(questions, concept) {
    if (questions.length === 0) {
      return;
    }

    const listItems = this.renderQuestionLinks(questions);
    return (
      <React.Fragment key={concept.uid}>
        {this.renderLabel(concept)}
        <ul className="menu-list">
          {listItems}
        </ul>
      </React.Fragment>
    );
  }

  mapConceptsToList() {
    const concepts = hashToCollection(this.props.concepts.data['0']);
    const questions = hashToCollection(this.props.questions);
    return concepts.map((concept) => {
      const questionsForConcept = questions.filter(q => getQuestionConceptUID(q) === concept.uid)
      return this.renderConceptWithQuestions(questionsForConcept, concept);
    })
  }

  render() {
    return (
      <aside className="menu">
        {this.mapConceptsToList()}
      </aside>
    );
  }
}

export { QuestionListByConcept }
